"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PHONE_ONLY_SYMBOLS = exports.PROFILE_PHONE_REGEX = exports.PHONE_REGEX = exports.NAME_REGEX = exports.LETTERS_AND_WHITESPACE_REGEX = exports.LETTERS_REGEX = exports.withoutTags = void 0;
const withoutTags = (input = '') => {
    const TAGS_TO_REMOVE = 'p_b_i_u_br_strong_em'.split('_');
    const getReplacement = (tag) => {
        return tag === 'br' ? ' ' : '';
    };
    return TAGS_TO_REMOVE.reduce((acc, tag) => acc.replace(new RegExp(`</?\\b${tag}\\b.*?>`, 'gi'), getReplacement(tag)), input);
};
exports.withoutTags = withoutTags;
const createLettersRegex = (additionalChars = '') => {
    return new RegExp(`^[a-zA-Zà-öù-žẞß${additionalChars}]*$`, 'i');
};
exports.LETTERS_REGEX = createLettersRegex();
exports.LETTERS_AND_WHITESPACE_REGEX = createLettersRegex('\\s');
/*
allow only the following characters:
space
.,-'
a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z
A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z
À,Â,Ã,Ä.à,â,ã,ä
ç,Ç
È,èÉ,é,Ê,ê,ë,Ë,
Ï,ï
ñ,Ñ
Ô,ô,Ö,ö
ü,Ü
ÿ
 */
exports.NAME_REGEX = /^[A-Za-zÀàÂâÃãÄäÇçÈèÉéÊêËëÏïÑñÔôÖöÜüÿ\s.,\-']*$/;
/*
Valid formats:
(123) 456-7890
(123)456-7890
123-456-7890
123.456.7890
1234567890
+31636363634
075-63546725
*/
exports.PHONE_REGEX = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im;
exports.PROFILE_PHONE_REGEX = /^\+[1-9][0-9]{7,}$/;
exports.PHONE_ONLY_SYMBOLS = /^[0-9()\s.+]*$/;
//# sourceMappingURL=strings.js.map